import Api from '@/lib/api'

export default {
    namespaced: true,
    state: {
        statuses: {
            start_now: 'Start Now',
            scheduled: 'Scheduled',
            tutor_accept: 'Tutor Accept',
            tutor_decline: 'Tutor Decline',
            student_decline: 'Student Decline',
            in_progress: 'In Progress',
            cancelled: 'Cancelled',
            time_out: 'Time out',
            finish: 'Finish',
            completed: 'Completed',
            tutor_pending: 'Tutor Pending'
        }
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        async updateLessonStatus({ commit }, { lessonId, newStatus, oldStatus, realMins }) {
            try {
                console.log(`Updating lesson ${lessonId} status from ${oldStatus} to ${newStatus} with ${realMins} real minutes`)
                
                // Make the actual API call to update lesson status
                const response = await Api().put(`/lessonsCms/${lessonId}`, {
                    status: newStatus,
                    realMins: realMins || 0
                })
                
                console.log('API Response received:', {
                    status: response.status,
                    data: response.data,
                    success: response.data ? response.data.success : 'undefined'
                })
                
                // Check for success - if API returns success: true, or if HTTP status is 2xx
                if (response.data && response.data.success === true) {
                    const message = response.data.message || 'Lesson status updated successfully'
                    return { success: true, message: message, data: response.data }
                } else if (response.status >= 200 && response.status < 300) {
                    // HTTP success but no explicit success flag
                    return { success: true, message: 'Lesson status updated successfully', data: response.data }
                } else {
                    // No success indicators found
                    const errorMessage = (response.data && response.data.message) || 'Failed to update lesson status'
                    throw new Error(errorMessage)
                }
                
            } catch (error) {
                console.error('Error updating lesson status:', error)
                throw new Error('Failed to update lesson status')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/lessons.js